import React, { ComponentProps } from 'react';
import {Button as MuiButton} from '@mui/material';

const StyledButton: React.FC<ComponentProps<typeof MuiButton>> = (props) => {
    return <MuiButton {...props} sx={{...props.sx, borderRadius: '12px', textTransform: 'none'}}/>
} 

export default StyledButton;